<template>
  <v-text-field :placeholder="cfg.label" v-model="val" :messages="cfg.messages"></v-text-field>
</template>
<script>
export default {
  name: "dialog-input",
  props: {
    cfg: Object,
  },
  data() {
    return {
      val: null,
    };
  },
};
</script>
